/* global module*/

import React, { Component } from 'react';
import get from 'lodash/get';
import { withT, wrap } from '../../../../lib/wrappers';
import { CustomizableLinkButton } from '../../../common/Customizable';
import numericInput from '../../../../lib/numericInput';
import Help from '../../../common/Help';

class ExternalOffsetComponent extends Component {

  constructor(props, context) {
    super(props, context);
    const external_offset = this;
    external_offset.state = {};
    const price_per_ton = get(props.ui, 'external_offset.cta.carbon_price_per_ton', 0);
    const totalUserFootprint = Math.round(get(props, 'totalUserFootprint', 0));
    const totalUserFootprintMonth = Math.round((totalUserFootprint * price_per_ton) / 12);
    const totalAcres = Math.round(totalUserFootprint / get(props.ui, 'widget.options.cta.acres_per_ton', 1));
    this.state = {
      totalUserFootprint,
      totalUserFootprintMonth,
      totalDonation: totalUserFootprintMonth,
      totalAcres,
    };
  }

  componentWillReceiveProps(newProps) {
    const price_per_ton = get(newProps.ui, 'external_offset.cta.carbon_price_per_ton');
    const totalUserFootprintMonth = Math.round((newProps.totalUserFootprint * price_per_ton) / 12);
    const totalAcres = Math.round(newProps.totalUserFootprint / get(newProps.ui, 'widget.options.cta.acres_per_ton', 1));

    if (newProps.totalUserFootprint !== this.props.totalUserFootprint ||
      get(newProps.ui, 'widget.options.cta.acres_per_ton', 1) !== get(this.props.ui, 'widget.options.cta.acres_per_ton', 1)) {
      this.setState({
        totalUserFootprint: Math.round(newProps.totalUserFootprint),
        totalUserFootprintMonth,
        totalDonation: totalUserFootprintMonth,
        totalAcres,
      });
    }
  }

  get t() {
    return this.props.t;
  }

  get offset_title() {
    return get(this.props.ui, 'external_offset.cta.title');
  }

  get show_equation() {
    return get(this.props.ui, 'external_offset.cta.show_equation');
  }

  get display_total_footprint() {
    return Math.round(this.props.totalUserFootprint);
  }

  get display_monthly_offset() {
    const price_per_ton = get(this.props.ui, 'external_offset.cta.carbon_price_per_ton');
    return Math.round((this.props.totalUserFootprint * price_per_ton) / 12);
  }

  get display_offset_description() {
    return get(this.props.ui, 'external_offset.cta.description');
  }
  get display_offset_image() {
    return get(this.props.ui, 'external_offset.cta.image');
  }

  get display_unit_description() {
    return get(this.props.ui, 'external_offset.cta.acres_label');
  }

  get display_donation_description() {
    return get(this.props.ui, 'external_offset.cta.donation_label', 'Total Donation');
  }
  get display_donation_description_help() {
    return get(this.props.ui, 'external_offset.cta.donation_label_help', null);
  }
  get display_annual_description_help() {
    return get(this.props.ui, 'external_offset.cta.annual_label_help', 'Your Annual Carbon Footprint (in tons CO2eq)');
  }


  get offset_button_title() {
    return get(this.props.ui, 'external_offset.cta.button_title');
  }

  get offset_url() {
    return get(this.props.ui, 'external_offset.cta.offset_url');
  }
  goToOffset(ev) {
    if (!get(this.props.ui, 'external_offset.cta.offset_url', null)) {
      ev.preventDefault();
      if (!window.parentIFrame) return;
      const message = {
        type: 'onClick',
        data: {
          value: Number(this.state.totalUserFootprint),
          acres: Number(this.state.totalAcres),
          donation: Number(this.state.totalDonation),
        },
      };
      window.parentIFrame.sendMessage(JSON.stringify(message));
    }
  }

  updateNumericInput(value) {
    this.setState({
      totalDonation: value,
    });
  }

  manualChangeTotalMonth(ev) {
    const price_per_ton = get(this.props.ui, 'external_offset.cta.carbon_price_per_ton');
    const totalUserFootprintMonth = Math.round((ev.target.value * price_per_ton) / 12);
    const totalAcres = Math.round(ev.target.value / get(this.props.ui, 'widget.options.cta.acres_per_ton', 1));
    const totalDonation = totalUserFootprintMonth;
    this.setState({
      totalUserFootprint: ev.target.value,
      totalUserFootprintMonth,
      totalDonation,
      totalAcres,
    });
  }

  render() {
    const totalUserFormat = numericInput.format(this.state.totalDonation,
      { decimalPlaces: 0 });
    const totalOptionsValues = [0.1, 0.25, 0.50, 0.75, 1, 1.25, 1.5, 1.75, 2];
    const totalOptions = totalOptionsValues.map(option => ({
      value: Math.round(this.state.totalUserFootprintMonth * option),
      display: `$${numericInput.format(this.state.totalUserFootprintMonth * option, { decimalPlaces: 0 })} (${option * 100}% of footprint)`,
    }));
    const customBackground = {};
    if (this.display_offset_image) {
      customBackground.backgroundImage = `url(${this.display_offset_image})`;
    }
    return (
      <div className="cc-component" id="external_offset">
        <div className="external-offset__banner" style={customBackground} />
        <div className="external-offset__title">
          <span
            className="cc-component__byline"
            dangerouslySetInnerHTML={{ __html: this.offset_title }}
          />
        </div>

        {this.show_equation &&
          <div className="external-offset__impact">
            <div className="external-offset__footprint">
              <h5>{this.display_total_footprint}</h5>
              <p
                dangerouslySetInnerHTML={{ __html: this.t('tons CO<sub>2</sub>/year', { ns: 'units' }) }}
              />
            </div>

            <div className="external-offset__equals">
              <span>=</span>
            </div>

            <div className="external-offset__price">
              <h5>${this.display_monthly_offset}</h5>
              <p>{this.t('monthly gift')}</p>
            </div>
          </div>
        }
        {(this.props.widgetSource === 'indigo' || this.props.widgetSource === 'ipl') &&
          <div className="row-fluid calculations-row">
            <div className="span6">
              <label htmlFor="total_offset_tons">{this.display_annual_description_help}</label>
              <div
                className="total_offset_tons"
                id="total_offset_tons"
              >{this.state.totalUserFootprint}</div>
            </div>
            <div className="span6">
              <label>{this.display_unit_description}</label>
              <div
                className="total_acres"
                id="total_acres"
              >{this.state.totalAcres}</div>
            </div>
            <div className="span6">
              <label>{this.display_donation_description}
                {this.display_donation_description_help ? (
                  <Help
                    popoverProps={{ id: 'help_donation' }}
                    helpText={this.display_donation_description_help}
                    faIcon="question-circle"
                  />)
                : null}
              </label>
              <div className="btn-group total_donation">
                <button
                  id="total_donation"
                  type="button"
                  className="btn btn-default dropdown-toggle"
                  data-toggle="dropdown"
                  // allow units display to include super and subscripts.
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: `$${totalUserFormat}&nbsp;<span class="caret"></span>` }}
                />
                <ul className="dropdown-menu">
                  {totalOptions.map(total => (
                    <li key={total.value}>
                      <a
                        href="#"
                        onClick={e => e.preventDefault() || this.updateNumericInput(total.value)}
                        // allow units display to include super and subscripts.
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: total.display }}
                      />
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        }
        <div className="external-offset__actions">
          <div className="external-offset__description">
            <p dangerouslySetInnerHTML={{ __html: this.display_offset_description }} />
          </div>

          <div className="external-offset__call-to-action">
            <CustomizableLinkButton
              ui={this.props.ui}
              href={this.offset_url}
              target="_top"
              className="btn btn-success btn-offset"
              onClick={ev => this.goToOffset(ev)}
            >{this.offset_button_title}</CustomizableLinkButton>
          </div>
        </div>
      </div>
    );
  }
}

ExternalOffsetComponent.NAME = 'ExternalOffset';
ExternalOffsetComponent.propTypes = {
  ui: React.PropTypes.object.isRequired,
  totalUserFootprint: React.PropTypes.string.isRequired,
  t: React.PropTypes.func.isRequired,
  widgetSource: React.PropTypes.any,
};

export default wrap(
  withT('takeAction'),
  ExternalOffsetComponent,
);
